import styled from 'styled-components';

export const SelectTagsContainer = styled.div`
	width: 200px;
`;

export const InputTextContainer = styled.div`
	width: 55px;
`;

export const FiltersContainer = styled.div`
	margin-right: 80px;
	margin-left: 80px;
	padding: 16px;
`;

export const ButtonsContainer = styled.div``;

export const GuestsAndTagsFilters = styled.div`
	display: flex;
	justify-content: center;
	gap: 50px;
	margin-bottom: 40px;
`;

export const MarginBottom = styled.div`
	margin-bottom: 40px;
`;
